import React, {useState} from 'react';
import {Layout,  Row, Col, Divider, Tag, Button, Space,  Badge} from 'antd';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import {useAxios} from '../../../../hooks';
const {Content, Footer} = Layout;

const useNFe = () => {
    const {getApiEmitirNotas} = useAxios();

    const informaCienciaOperacao = async (chaveNFe) => {
        const api = await getApiEmitirNotas();
        const result = await api.post("/fiscal/nfe-contra/"+chaveNFe+"/ciencia-operacao");
        return result.data;
    }

    const download = async (chaveNFe) => {
        const api = await getApiEmitirNotas();
        const result = await api.post("/fiscal/nfe-contra/"+chaveNFe+"/download");
        return result.data;
    }

    return {informaCienciaOperacao, download};
}

const DetalhaResumoNFe = props => {

    const {informaCienciaOperacao, download} = useNFe();
    const [loading, setLoading] = useState(false);

    const {nfe, enviaCienciaOperacaoEvt, downloadEvt} = props;

    const tagCienciaOperacao = () =>{
        let tag = (<></>);
        if(nfe.statuCienciaOperacao === "SEM_CIENCIA"){
            tag = (<Tag color="red">{nfe.statuCienciaOperacao.replace(/_/gm, " ")}</Tag>)
        } else {
            tag = (<Tag color="green">{nfe.statuCienciaOperacao.replace(/_/gm, " ")}</Tag>);
        }

        
       
        return (
        <Space direction="vertical" size="large">
            <Row style={{
                textAlign: "left"
            }}>
                <Col span={24}>
                    Ciencia de Operação {tag} 
                </Col>
       
                
            </Row>
            <Row   style={{
                textAlign: "left",
                verticalAlign: "middle"
            }}>
                <Col span={6} style={{
                    textAlign: "center",
                    
                }}>
                    <FontAwesomeIcon style={{
                        
                    }} size="5x" icon={faInfoCircle}></FontAwesomeIcon>
                </Col>
                <Col span={18} >
                    <h3>Sobre a ciência de operação</h3>
                    <p>
                        A ciencia de operação é um documento (em xml) que é enviado à Sefaz para informá-la que você sabe da existencia da emissão dessa nota fiscal. Isso não significa o reconhecimento de que a operação ocorreu de fato. Apenas depois de informar a ciência da operação, o documento fica disponível no ambiente nacional para o download completo das informações.
                    </p>

                </Col>
            </Row>
        </Space>);

    }

    const renderizaOpcoesEnvioCienciaOperacao = () => {

        
        const btnClickHandle = async () => {
            setLoading(true);
            try{
                await informaCienciaOperacao(nfe.chaveNFe);
            } catch(e){
                console.log(e);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 5000);
                enviaCienciaOperacaoEvt();
                
            }
        }
        if(nfe.estadoProcessamento === "ENVIANDO_CIENCIA_OPERACAO"){
            return (<><Badge status="processing" />Aguardando Sefaz Responder Ciencia da Operacao</>);
            
        }
        return (
            <Button type="primary" onClick={btnClickHandle} loading={loading} >Informar Ciencia Operacao</Button>
        )
    }

    const renderizaOpcaoDownload = () => {
        
        const onClickDownloadHandle = async () =>{
            setLoading(true);
            try{
                await download(nfe.chaveNFe);
            } catch(e){
                console.log(e);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 5000);
                downloadEvt();
            }
        }

        if(nfe.estadoProcessamento === "EFETUANDO_DOWNLOAD"){
            return (<><Badge status="processing" />Aguardando Sefaz Responder Solicitacao de Download</>);
            
        }

        return (
            <Button type="primary" loading={loading} onClick={onClickDownloadHandle} >Solicitar Download</Button>
        )
    }

    const renderizaOpcoesAcao = () => {
        let retorno;
        if(nfe.statuCienciaOperacao === "SEM_CIENCIA"){
            retorno = renderizaOpcoesEnvioCienciaOperacao()
        } else {
            retorno = renderizaOpcaoDownload();
        }

        return(<Row style={{
                    textAlign: "right"
                }}>
                    <Col span={24}>
                        {retorno}
                    </Col>
                </Row>);

    }

    return (<Layout style={{background: "#FFF", height: "calc(100vh - 190px)"}}>
                <Content>

                    <Row className="cabecalho">
                        <Col span={12} className='dadosEmitente'>
                            <span className='nome'>{nfe.nome}</span>
                            <span className='documento'>CNPJ: {nfe.CNPJ}</span>
                            <span className='documento'>IE: {nfe.IE}</span>
                        </Col>
                        <Col span={12} className='dadosNFe'>
                            <span className='chaveNFe'>{nfe.chaveNFe}</span>
                            <span className="dataEmissao">{moment(nfe.dataEmissao).format('DD/MM/YYYY HH:mm:ss')}</span>
                            <span className="dataEmissao">{nfe.vNF}</span>
                        </Col>
                    </Row>
                    <Divider></Divider>
                    <Row>
                        {tagCienciaOperacao()}
                    </Row>
                    
                </Content>
                <Footer style={{
                    padding: "0",
                    background: "#FFF"
                }}>
                        {renderizaOpcoesAcao()}
                </Footer>
                
                
            </Layout>)
}

export {DetalhaResumoNFe};